import lazyWithRetry from 'tools/lazyWithRetry';

const GlobalConfigPage = lazyWithRetry(() => import(
	/* webpackChunkName: "globalConfigPage" */
	'../../pages/GlobalConfig/GlobalConfigPage'));

export default [
	{
		component: GlobalConfigPage,
		exact: true,
		path: '/global_config',
	},
];